import {
  requestSystemNotificationPermission,
  sendSystemNotification,
} from '@/platform/bridge'

type AppSystemNotificationOptions = { title: string; body?: string | null }

export async function ensureAppSystemNotificationPermission(): Promise<boolean> {
  return requestSystemNotificationPermission()
}

export async function sendAppSystemNotification(options: AppSystemNotificationOptions) {
  await sendSystemNotification(options)
}
